import Joi from '@hapi/joi'

export const EmployeeSessionImageSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Estate`,
        "any.required": `Estate required`
    }),
    divisionID: Joi.number().invalid(0).required().label("Division").messages({
        "any.invalid": `Select Division`,
        "any.required": `Division required`
    }),

    narration: Joi.string().required().label("Narration").messages({
        "string.empty": "Select Narration",
    }),

    date: Joi.string().invalid("").required().label("Date"),

}